module.exports = __webpack_public_path__ + "img/app_d.08cd24d6.png";